/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ResourceEntry } from '../model/resource-entry.model';

export class ResourcesProvider {
  private static resourcesMap = new Map<string, { [key: string]: ResourceEntry }>();

  static registerResources(key: string, resources: { [key: string]: ResourceEntry }) {
    ResourcesProvider.resourcesMap.set(key, resources);
  }

  static resolveResources(key: string): { [key: string]: ResourceEntry } {
    return ResourcesProvider.resourcesMap.get(key);
  }

  static getResources(): Map<string, { [key: string]: ResourceEntry }> {
    return ResourcesProvider.resourcesMap;
  }

}
